import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contact-info__header" }
const _hoisted_2 = { class: "contact-info__field" }
const _hoisted_3 = { class: "contact-info__field--text" }
const _hoisted_4 = { class: "contact-info__field--text-weight" }
const _hoisted_5 = { class: "contact-info__field--text-weight" }
const _hoisted_6 = { class: "contact-info__field--buttons" }
const _hoisted_7 = { class: "contact-info__header" }
const _hoisted_8 = { class: "contact-info__field" }
const _hoisted_9 = { class: "contact-info__field-radio" }
const _hoisted_10 = {
  class: "contact-info__field--buttons",
  style: {"justify-content":"center"}
}
const _hoisted_11 = { class: "contact-info__header" }
const _hoisted_12 = { class: "contact-info__field" }
const _hoisted_13 = { class: "contact-info__field-radio" }
const _hoisted_14 = { class: "contact-info__field--buttons" }
const _hoisted_15 = { class: "contact-info__header" }
const _hoisted_16 = { class: "contact-info__field" }
const _hoisted_17 = {
  style: {"align-self":"center","max-width":"204px"},
  class: "contact-info__field--text"
}
const _hoisted_18 = {
  style: {"align-self":"center"},
  class: "contact-info__field--buttons"
}
const _hoisted_19 = { class: "contact-info__header" }
const _hoisted_20 = { class: "contact-info__field" }
const _hoisted_21 = { class: "contact-info__field--text" }
const _hoisted_22 = { class: "contact-info__field--text-weight" }
const _hoisted_23 = { class: "contact-info__field--buttons" }
const _hoisted_24 = { class: "contact-info__header" }
const _hoisted_25 = { class: "contact-info__field" }
const _hoisted_26 = { class: "contact-info__field--text" }
const _hoisted_27 = { class: "contact-info__field--text-weight" }
const _hoisted_28 = {
  key: 0,
  style: {"font-weight":"400","color":"#4d4d4d"}
}
const _hoisted_29 = { class: "contact-info__field--buttons" }
const _hoisted_30 = { class: "contact-info__header" }
const _hoisted_31 = { class: "contact-info__field" }
const _hoisted_32 = { class: "contact-info__field--text" }
const _hoisted_33 = { class: "contact-info__field--text-weight" }
const _hoisted_34 = { class: "contact-info__field--buttons" }
const _hoisted_35 = { class: "contact-info__header" }
const _hoisted_36 = { class: "contact-info__field" }
const _hoisted_37 = { class: "contact-info__field--text" }
const _hoisted_38 = { class: "contact-info__field--text-weight" }
const _hoisted_39 = { class: "contact-info__field--buttons" }

import FileCard from "./FileCard.vue";
import { computed, nextTick, onUnmounted, ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppRadioButton from "@/components/ui-kit/radio-button/AppRadioButton.vue";
import {
  FileOut,
  FolderOut,
} from "@/models/interfaces/file/file-model";
import { i18n } from "@/i18n";
import { useBreakpoints } from "@/composables/useBreakpoints";
import { useModalEscape } from "@/composables/useModalEscape";
import { isTopmostOverlay } from "@/composables/overlayStack";

type ModalPosition = { x: number; y: number };

interface Props {
  type?:
    | "replace"
    | "move"
    | "error"
    | "replaceUpload"
    | "remove"
    | "removeFile"
    | "removeFolder"
    | "abortFile";
  errorType?: string;
  position?: ModalPosition | null;
}

const MODAL_WIDTH = 235;
const MODAL_HEIGHT_FALLBACK = 160;
const MODAL_MARGIN = 8;


export default /*@__PURE__*/_defineComponent({
  __name: 'FileMoveModal',
  props: {
    type: { default: "move" },
    errorType: { default: "size" },
    position: {}
  },
  emits: [
  "successMove",
  "successReplace",
  "successReplaceUpload",
  "successRemove",
  "successRemoveFile",
  "successRemoveFolder",
  "successAbortFile",
  "closeError",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const selectedReplaceOption = ref<boolean>(true);

const $modal = ref<InstanceType<typeof FileCard> | null>(null);
const isLoading = ref(false);
const $content = ref<HTMLElement | null>(null);
const targetDir = ref<FolderOut>();
const targetFile = ref<FileOut>();
const countEl = ref();
const errorText = ref("");
const props = __props;

const { isMobile } = useBreakpoints();

const pluralize = (
  n: number,
  one: string,
  few: string,
  many: string,
): string => {
  const abs = Math.abs(n) % 100;
  const mod10 = abs % 10;
  if (abs >= 11 && abs <= 19) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
};

const label = computed(() => {
  const n = countEl.value ?? 0;
  return `${n} ${pluralize(
    n,
    String(i18n.global.t("confirm_elements_one")),
    String(i18n.global.t("confirm_elements_few")),
    String(i18n.global.t("confirm_elements_many")),
  )}`;
});

const getCenteredPosition = (): ModalPosition => ({
  x: window.scrollX + (window.innerWidth - MODAL_WIDTH) / 2,
  y: window.scrollY + (window.innerHeight - MODAL_HEIGHT_FALLBACK) / 2,
});

const safePosition = computed<ModalPosition | null>(() => {
  if (
    isMobile.value &&
    ["remove", "removeFile", "removeFolder", "error"].includes(props.type)
  ) {
    return null;
  }

  const raw = props.position;

  const position =
    raw &&
    Number.isFinite(raw.x) &&
    Number.isFinite(raw.y) &&
    !(raw.x === 0 && raw.y === 0)
      ? raw
      : getCenteredPosition();

  const minX = window.scrollX + MODAL_MARGIN;
  const minY = window.scrollY + MODAL_MARGIN;

  const maxX = window.scrollX + window.innerWidth - MODAL_WIDTH - MODAL_MARGIN;

  const maxY =
    window.scrollY + window.innerHeight - MODAL_HEIGHT_FALLBACK - MODAL_MARGIN;

  return {
    x: Math.min(Math.max(position.x, minX), maxX),
    y: Math.min(Math.max(position.y, minY), maxY),
  };
});

const success = () => {
  switch (props.type) {
    case "replace":
      emit("successReplace", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "move":
      emit("successMove", targetDir.value);
      $modal.value?.onClose();
      break;

    case "replaceUpload":
      emit("successReplaceUpload", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "remove":
      emit("successRemove");
      $modal.value?.onClose();
      break;

    case "removeFile":
      emit("successRemoveFile", targetDir.value, targetFile.value);
      $modal.value?.onClose();
      break;

    case "removeFolder":
      emit("successRemoveFolder", targetDir.value);
      $modal.value?.onClose();
      break;

    case "abortFile":
      emit("successAbortFile");
      $modal.value?.onClose();
      break;

    case "error":
      emit("closeError");
      $modal.value?.onClose();
      break;
  }

  $modal.value?.onClose();
};

const chooseError = () => {
  switch (props.errorType) {
    case "size":
      errorText.value = String(i18n.global.t("file_error_max_size"));
      break;

    case "extension":
      errorText.value = String(i18n.global.t("file_error_formats_mismatch"));
      break;

    case "folder":
      errorText.value = String(i18n.global.t("file_error_external_folder"));
      break;

    case "notFound":
      errorText.value = String(i18n.global.t("file_not_found"));
      break;

    case "folderNameMatch":
      errorText.value = String(i18n.global.t("file_folder_name_exists"));
      break;

    case "fileNameMatch":
      errorText.value = String(i18n.global.t("file_name_exists"));
      break;

    case "chooseAccessDenied":
      errorText.value = String(i18n.global.t("file_error_partial_access"));
      break;
  }

  // $modal.value?.onClose();
};

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.onClose()
});

const handleEnter = (e: KeyboardEvent) => {
  if (e.key !== "Enter") {
    return;
  }
  if (e.repeat) {
    return;
  }
  if (!isTopmostOverlay($content.value)) {
    return;
  }
  // Пользователь дошёл табом до конкретной кнопки — пусть Enter нажмёт именно её.
  if (document.activeElement instanceof HTMLButtonElement) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  success();
};

const activateKeys = () => {
  activateEsc();
  window.addEventListener("keydown", handleEnter, true);
};

const deactivateKeys = () => {
  deactivateEsc();
  window.removeEventListener("keydown", handleEnter, true);
};

onUnmounted(deactivateKeys);

const onClose = () => {
  $modal.value?.onClose();
};

const onOpen = async (dir?: FolderOut, count?: number, file?: FileOut) => {
  try {
    $modal.value?.onOpen();
    activateKeys();

    await nextTick();

    targetDir.value = dir;
    targetFile.value = file;
    countEl.value = count;

    if (props.type == "error") {
      chooseError();
    }
  } catch (e) {
    console.error(e);
  }
};

__expose({ onOpen, onClose });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FileCard, {
    ref_key: "$modal",
    ref: $modal,
    onOnClose: deactivateKeys,
    position: safePosition.value,
    loading: isLoading.value,
    height: "auto",
    width: "235px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "contact-info"
      }, [
        (_ctx.type == 'move')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("confirm_move_elements_title")), 1),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t("confirm_move_prefix")) + " ", 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(label.value), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("file_move_to_folder")) + " ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(targetDir.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'replace')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("file_replacement")), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: _ctx.$t('file_keep_current_name'),
                    name: "answer",
                    "radio-value": true
                  }, null, 8, ["modelValue", "text"]),
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: _ctx.$t('file_apply_new_name'),
                    name: "answer",
                    "radio-value": false
                  }, null, 8, ["modelValue", "text"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('file_replace'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'replaceUpload')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("file_name_exists")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: _ctx.$t('file_replace_file'),
                    name: "answer",
                    "radio-value": true
                  }, null, 8, ["modelValue", "text"]),
                  _createVNode(AppRadioButton, {
                    modelValue: selectedReplaceOption.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedReplaceOption).value = $event)),
                    text: _ctx.$t('file_keep_both_versions'),
                    name: "answer",
                    "radio-value": false
                  }, null, 8, ["modelValue", "text"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'error')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("file_error")), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(errorText.value), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('file_ok'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'remove')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("confirm_delete_elements_title")), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.$t("confirm_delete_prefix")) + " ", 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(label.value), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'removeFile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("file_delete_file_title")), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_ctx.$t("file_delete_file_prefix")) + " ", 1),
                  _createElementVNode("span", _hoisted_27, [
                    _createTextVNode(_toDisplayString(targetFile.value?.Name), 1),
                    (targetFile.value?.JobBindings.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "."))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(targetFile.value?.JobBindings.length > 0
                ? _ctx.$t(
                    targetFile.value?.JobBindings.length === 1
                      ? "file_attached_job"
                      : "file_attached_jobs",
                    { count: targetFile.value?.JobBindings.length },
                  )
                : ""), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'removeFolder')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("file_delete_folder_title")), 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.$t("file_delete_folder_prefix")) + " ", 1),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(targetDir.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type == 'abortFile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("file_abort_upload_title")), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createTextVNode(_toDisplayString(_ctx.$t("file_abort_upload_prefix")) + " ", 1),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(targetFile.value?.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(AppButton, {
                    type: "secondary",
                    label: _ctx.$t('cancel_short'),
                    onClick: onClose
                  }, null, 8, ["label"]),
                  _createVNode(AppButton, {
                    type: "primary",
                    label: _ctx.$t('confirm_short'),
                    onClick: success
                  }, null, 8, ["label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }, 8, ["position", "loading"]))
}
}

})